<template>
	<page>
		<module title="券码核销">
			<div class="box">
				<div class="input flex-center">
					<input v-model="code" ref="input" class="flex-grow" type="text" placeholder="请输入核销码" @keydown.enter="enter">
					<i class="tf tf-qrcode"></i>
				</div>
				
				<div class="fruit flex-column flex-center">
					<p v-if="!codeDetail" class="tips">请在上方输入核销码并按回车键(Enter)</p>
					<div v-else>
						<div v-if="codeDetail.id" class="detail flex-column flex-center">
							<p class="name">{{codeDetail.code}}</p>
							<p v-if="codeDetail.state == 1" class="state" style="color:green">待核销</p>
							<p v-if="codeDetail.state == 2" class="state" style="color:#f00">已核销</p>
							<p v-if="codeDetail.state == 2" class="date">核销时间：{{codeDetail.use_date}}</p>
							<p v-if="codeDetail.state == 3" class="tips">该卡券已过期！</p>
							<p v-if="codeDetail.state == 4" class="tips">该卡券已失效！</p>
							<c-image class="image" :src="codeDetail.product_img_url"></c-image>
							<p class="name ellipsis">{{codeDetail.product_name}}</p>
							<p class="name">{{codeDetail.product_sku_spec}}</p>
							<p class="member">代理：{{codeDetail.user_manage_mobilephone}}【{{codeDetail.nick_name}}】</p>
							<p class="stationed">商家：{{codeDetail.company_name}}</p>
						</div>
						<p v-else class="tips error">未找到相关商品与服务，请确认输入的核销码</p>
					</div>
				</div>
				
				<c-button v-if="codeDetail && codeDetail.state == 1" class="button" color="sys" width="300" height="50" size="20" @click="verify">确认核销</c-button>
			</div>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'service_card_detail',
		
		data() {
			return {
				code: '',
				enCode: '',
				codeDetail: '',
				error_msg:''
			}
		},
		
		mounted() {
			this.$refs.input.focus();
		},
		
		methods: {
			enter() {
				if (!this.code) {
					this.$message({
						text: '请输入核销码'
					});
					return;
				}
				this.enCode = this.code;
				this.code ='';
				this.query();
			},
			//查询
			query(){
				this.request({
					url: '/service/card/detail',
					data: {
						code: this.enCode
					},
					loading: true,
					success: data => {
						this.codeDetail = data || {};
					}
				});
			},
			
			verify() {
				this.request({
					url: '/service/card/use',
					data: {
						code: this.enCode
					},
					loading: true,
					success: data => {
						this.$message({
							icon: 'success',
							text: '核销成功！'
						});
						this.query();
						this.code = '';
						this.$refs.input.focus();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.box {
		max-width: 1000px;
		margin: 0 auto;
	}
	
	.input {
		height: 50px;
		border: 1px solid #ddd;
		margin: 38px 0 14px;
		
		input {
			border: none;
			padding: 0 17px;
			font-size: 18px;
		}
		
		.tf {
			margin: 0 14px;
			font-size: 18px;
			color: #999;
		}
	}
	
	.fruit {
		height: 600px;
		background: #FAFAFA;
		
		.tips {
			font-size: 16px;
			color: #bbb;
		
			&.error {
				color: #f55;
			}
		}
		
		.detail {
			.state {
				font-size: 20px;
			}
			
			.date {
				margin-top: 10px;
				font-size: 14px;
			}
			
			.image {
				width: 300px;
				height: 300px;
				margin-top: 16px;
			}
			
			.name {
				max-width: 300px;
				line-height: 42px;
				font-size: 16px;
				font-weight: bold;
			}
			
			.member {
				margin-top: 20px;
				font-size: 18px;
			}
			
			.stationed {
				margin-top: 10px;
				font-size: 18px;
			}
		}
	}
	
	.button {
		display: block;
		margin: 28px auto;
	}
</style>